import moment from 'moment';

import { aTypeFetchEventsBySalon } from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import fromActionTypeToArray from 'utils/converters/mw/fromActionTypeToArray.util';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';

// TODO: convert to the newest form using actionEndpointBe
const fetchEventsBySalon = (salonId, startDate, endDate, stylistId) => {
  const query = {
    start: moment(startDate).clone().startOf('day').toISOString(),
    end: moment(endDate ? endDate : startDate)
      .clone()
      .endOf('day')
      .toISOString(),
  };

  if (stylistId) query.stylist = stylistId;

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/${salonId}/event/?${fromObjectToQueryString(query)}`,
      authenticated: true,
      notifyOnError: true,
      types: fromActionTypeToArray(aTypeFetchEventsBySalon),
      params: { id: salonId, ...query },
    },
  };
};

export default fetchEventsBySalon;
